export enum SeoFaqToggleType {
  FaqOpen = 'faq_open',
  FaqClose = 'faq_close',
}
